"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const lodash_1 = require("lodash");
const formik_1 = require("formik");
const categories_1 = require("companion-app-components/flux/categories");
const scheduledTransactionsTypes_1 = require("companion-app-components/flux/scheduled-transactions/scheduledTransactionsTypes");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const CategoryField_1 = __importDefault(require("components/QuickenControls/CategoryField"));
const utils_1 = require("./utils");
const RecrCategoryField = ({ classes, name, formikProps }) => (<formik_1.Field name={name} validate={(coa) => {
        let error = '';
        switch (formikProps.values.type) {
            case scheduledTransactionsTypes_1.STTypeEnum.INCOME:
                if (!coa || (coa.type !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.BALANCE_ADJUSTMENT && coa.type !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY) ||
                    (coa.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY && !categories_1.categoriesSelectors.isIncomeCat(null, coa.id))) {
                    error = 'valid income category required';
                }
                break;
            case scheduledTransactionsTypes_1.STTypeEnum.TRANSFER:
                if (!coa || (coa.type !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.ACCOUNT && coa.type !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.BALANCE_ADJUSTMENT)) {
                    error = 'valid account required';
                }
                break;
            case scheduledTransactionsTypes_1.STTypeEnum.BILL:
            case scheduledTransactionsTypes_1.STTypeEnum.EXPENSE:
                if (!coa || (coa.type !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY && coa.type !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.BALANCE_ADJUSTMENT && coa.type !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED)) {
                    error = 'valid bill category required';
                }
                break;
            case scheduledTransactionsTypes_1.STTypeEnum.SUBSCRIPTION:
                if (!categories_1.categoriesSelectors.isExpenseCat(null, coa.id) && coa.type !== chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.UNCATEGORIZED) {
                    error = 'valid subscription category required';
                }
                break;
            default:
        }
        return error;
    }}>
    {({ field, form: { touched, errors } }) => (<CategoryField_1.default {...field} onChange={(coa) => formikProps.setFieldValue(field.name, coa)} error={Boolean((0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name))} label={formikProps.values.type === scheduledTransactionsTypes_1.STTypeEnum.TRANSFER ? 'Account' : 'Category'} editable createEnabled longCats={false} margin="dense" autoFocus={false} fontSize="16px" inputStyle={classes.categories} filterFn={(coa) => (0, utils_1.filterFn)(coa, formikProps.values.type)} InputProps={{
            classes: { underline: classes.underlineOverride },
            id: 'transaction-input',
        }} textFieldProps={{
            helperText: (0, lodash_1.get)(touched, field.name) && (0, lodash_1.get)(errors, field.name),
        }} transferOnly={formikProps.values.type === scheduledTransactionsTypes_1.STTypeEnum.TRANSFER} stType={formikProps.values.type}/>)}
  </formik_1.Field>);
exports.default = RecrCategoryField;
